import { Injectable } from '@angular/core';
import { ScriptLoaderService } from '@app/shared/services/script-loader/script-loader.service';
import { Logger } from '@app/shared/utils';

@Injectable({ providedIn: 'root' })
export class Rb2bService {
  constructor(private scriptLoader: ScriptLoaderService) {}

  // Sales use this rb2b tool (app.rb2b.com) to track visitors
  // We want to load this only on the signup pages
  // It adds no value for the rest of the app

  init() {
    this.scriptLoader
      .load({
        name: 'Rb2b',
        src: '/assets/js/rb2b.js',
      })
      .subscribe({
        next: () => {
          // Logger.log('Rb2b loaded');
        },
        error: () => {
          Logger.log('Rb2b failed to load');
        },
      });
  }
}
